"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBlankString = (...others) => "";
exports.default = exports.toBlankString;
//# sourceMappingURL=to_blank_string.js.map